import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Heart, Lock, Loader2 } from "lucide-react";
import { adminLogin } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = await adminLogin(u, p);
      localStorage.setItem("wh_admin_token", token);
      toast.success("Welcome, keeper of numbers.");
      nav("/admin/dashboard");
    } catch {
      toast.error("Invalid credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full cream-bg text-[#1C1917] flex flex-col items-center justify-center px-6">
      <Link to="/" className="mb-10 flex items-center gap-2 text-[#4c3f34] hover:text-[#1C1917]">
        <Heart size={16} className="text-[#991B1B]" fill="#991B1B" />
        <span className="font-serif-elegant text-lg">WrittenHearts</span>
      </Link>

      <div className="w-full max-w-md paper-bg rounded-[4px] p-10 text-[#1C1917]">
        <div className="flex items-center gap-2 uppercase tracking-[0.35em] text-xs text-[#991B1B]">
          <Lock size={12} /> Admin
        </div>
        <h1 className="mt-3 font-serif-elegant text-4xl">Dashboard access</h1>
        <p className="mt-2 text-sm text-[#4c3f34]">Analytics only. Never letter content.</p>

        <form onSubmit={submit} className="mt-8 space-y-6">
          <div>
            <label className="block text-xs uppercase tracking-widest text-[#4c3f34]">Username</label>
            <input
              data-testid="admin-username"
              value={u}
              onChange={(e) => setU(e.target.value)}
              className="w-full bg-transparent border-b border-[#1C1917]/20 focus:border-[#1C1917] outline-none py-2 text-lg"
              autoFocus
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-[#4c3f34]">Password</label>
            <input
              data-testid="admin-password"
              type="password"
              value={p}
              onChange={(e) => setP(e.target.value)}
              className="w-full bg-transparent border-b border-[#1C1917]/20 focus:border-[#1C1917] outline-none py-2 text-lg"
            />
          </div>
          <button
            data-testid="admin-login-btn"
            type="submit"
            disabled={loading}
            className="w-full px-6 py-3 rounded-full bg-[#991B1B] text-white hover:bg-[#7F1D1D] transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
          >
            {loading && <Loader2 size={14} className="animate-spin" />}
            Enter dashboard
          </button>
        </form>
      </div>
    </div>
  );
}
